import React from "react";
import { BaseQuestionType, QuestionListItem } from "service/question";
import style from "./index.module.scss";
import { indexToChar } from "../../../../../../utils/common";

interface TopicDetailProps {
    data: QuestionListItem;
    index?: number;
}

export default function TopicDetail({ data, index }: TopicDetailProps) {
    return (
        <div className={style.root}>
            <div className={style.info}>
                <em>{data?.index ? data.index : `(${index})`}.</em>
            </div>

            <div className={style.trunk}>
                <div
                    className={style.title}
                    dangerouslySetInnerHTML={{ __html: data.contentText }}
                />
            </div>

            {/* 多选，单选选项 */}
            <div className={style.options}>
                {[
                    BaseQuestionType.SingleChoice,
                    BaseQuestionType.MultipleChoice
                ].includes(data.queTypeId) &&
                    data.optionModelList.map((item, index) => {
                        return (
                            <div key={item.id}>
                                {indexToChar(index)}.
                                <div
                                    className={style.option}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
